import React, { useEffect } from 'react';
import { Routes, Route, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { MastersContext } from './context/masters-context';
import { Home } from './home';

export function App(): JSX.Element {
	const {
		featureAppId,
		authService,
		profileService,
		userService,
		layerManager,
		serviceConfigProvider,
		historyService,
		portalService,
	} = React.useContext(MastersContext);

	console.log('🚀 ~ App ~ featureAppId', featureAppId);
	console.log('🚀 ~ App ~ authService', authService);
	console.log('🚀 ~ App ~ profileService', profileService);
	console.log('🚀 ~ App ~ userService', userService);
	console.log('🚀 ~ App ~ layerManager', layerManager);
	console.log('🚀 ~ App ~ serviceConfigProvider', serviceConfigProvider);
	console.log('🚀 ~ App ~ portalService', portalService);

	useEffect(() => {
		const unregister = historyService.history.listen(() => {
			console.log('history changes', historyService.history.location.pathname);
		});
		return unregister;
	});

	console.log('pathname', historyService.history.location.pathname);

	return (
		<HistoryRouter history={historyService.history as any}>
			<Routes>
				<Route path="/" element={<Home />}></Route>
				<Route path="/quiz" element={<></>}></Route>
			</Routes>
		</HistoryRouter>
	);
}
